<template>
  <v-dialog v-model="dialog" max-width="887" style="border-radius: 20px">
    <v-card elevation="0" class="card-save-petty pt-4 pb-4">
      <v-form ref="saveCutBudgetForm" lazy-validation>
        <v-row no-gutters class="standard-row font-theme pb-1" align="center">
          <v-col
            cols="12"
            sm="auto"
            md="auto"
            lg="auto"
            style="font-size: 16px; font-weight: 700"
            class="text-center pl-sm-6"
          >
            ตัดงบเงินยืมคืน
          </v-col>
          <v-spacer></v-spacer>
          <v-col
            cols="12"
            sm="auto"
            md="auto"
            lg="auto"
            class="pl-6 pl-sm-0 ml-sm-5"
          >
            <v-radio-group
              class="mt-0 pt-0"
              hide-details
              row
              v-model="cutBudgetData[0].in_budget"
              :rules="[(v) => v !== null && v !== undefined]"
              required
            >
              <v-radio
                class="font-theme"
                :value="true"
                color="#D9D9D9"
                on-icon="mdi-checkbox-marked"
                off-icon="mdi-checkbox-blank-outline"
                :ripple="false"
              >
                <template v-slot:label>
                  <span class="check-box-petty-cash-modal">ในงบประมาณ</span>
                </template>
              </v-radio>
              <v-radio
                class="font-theme"
                :value="false"
                color="#D9D9D9"
                on-icon="mdi-checkbox-marked"
                off-icon="mdi-checkbox-blank-outline"
                :ripple="false"
              >
                <template v-slot:label>
                  <span class="check-box-petty-cash-modal">นอกงบประมาณ</span>
                </template>
              </v-radio>
            </v-radio-group>
          </v-col>
          <v-row
            no-gutters
            class="standard-row font-theme pl-6 pr-2 pt-3"
            align="center"
          >
            <v-col class="custom-container-col" cols="12">
              <v-row no-gutters class="standard-row font-theme" align="center">
                <v-col cols="12" sm="6" md="6" lg="6">
                  <v-row
                    no-gutters
                    class="standard-row font-theme pt-2"
                    align="center"
                  >
                    <v-col
                      class="custom-col-text"
                      cols="4"
                      sm="12"
                      md="6"
                      lg="6"
                      style="font-size: 14px"
                    >
                      งบประมาณปี
                    </v-col>
                    <v-col
                      class="custom-col-textfield"
                      cols="8"
                      sm="12"
                      md="6"
                      lg="6"
                    >
                      <v-text-field
                        height="24"
                        color="black"
                        hide-details
                        outlined
                        v-model="thisYear"
                        class="pr-4 text-box-petty-cash-modal"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" sm="6" md="6" lg="6">
                  <v-row
                    no-gutters
                    class="standard-row font-theme pt-2"
                    align="center"
                  >
                    <v-col
                      class="custom-col-text"
                      cols="4"
                      sm="12"
                      md="6"
                      lg="6"
                      style="font-size: 14px"
                    >
                      Type Budget
                    </v-col>
                    <v-col
                      class="custom-col-textfield"
                      cols="8"
                      sm="12"
                      md="6"
                      lg="6"
                    >
                      <v-select
                        :items="typeBudgetItems"
                        v-model="cutBudgetData[0].budget_type"
                        @change="updateAllBudgetType"
                        hide-details
                        outlined
                        dense
                        height="24"
                        append-icon="mdi-chevron-down"
                        item-color="#D9D9D9"
                        color="black"
                        class="pr-4 dropdown-external-petty-cash-modal"
                      >
                      </v-select>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-row no-gutters class="standard-row font-theme" align="center">
                <v-col cols="12" sm="6" md="6" lg="6">
                  <v-row
                    no-gutters
                    class="standard-row font-theme pt-2"
                    align="center"
                  >
                    <v-col
                      class="custom-col-text"
                      cols="4"
                      sm="12"
                      md="6"
                      lg="6"
                      style="font-size: 14px"
                    >
                      Start Date
                    </v-col>
                    <v-col
                      class="custom-col-textfield"
                      cols="8"
                      sm="12"
                      md="6"
                      lg="6"
                    >
                      <v-menu
                        :close-on-content-click="false"
                        offset-y
                        min-width="auto"
                        v-model="dateStart"
                        transition="scale-transition"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            height="24"
                            color="black"
                            hide-details
                            readonly
                            outlined
                            v-on="on"
                            :value="startDateTextShow"
                            :rules="[rules.required]"
                            required
                            class="pr-4 text-box-save-budget-modal"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          color="#0B68D6"
                          no-title
                          show-current
                          locale="th"
                          v-model="start_date"
                          :max="end_date"
                          @change="dateMenuReset"
                          @input="dateStart = false"
                          class="font-theme date-picker-save-budget-modal"
                        ></v-date-picker>
                      </v-menu>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" sm="6" md="6" lg="6">
                  <v-row
                    no-gutters
                    class="standard-row font-theme pt-2"
                    align="center"
                  >
                    <v-col
                      class="custom-col-text"
                      cols="4"
                      sm="12"
                      md="6"
                      lg="6"
                      style="font-size: 14px"
                    >
                      End Date
                    </v-col>
                    <v-col
                      class="custom-col-textfield"
                      cols="8"
                      sm="12"
                      md="6"
                      lg="6"
                    >
                      <v-menu
                        :close-on-content-click="false"
                        offset-y
                        min-width="auto"
                        v-model="dateEnd"
                        transition="scale-transition"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            height="24"
                            color="black"
                            hide-details
                            readonly
                            outlined
                            v-on="on"
                            :value="endDateTextShow"
                            :rules="[rules.required]"
                            required
                            class="pr-4 text-box-save-budget-modal"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          color="#0B68D6"
                          no-title
                          show-current
                          locale="th"
                          v-model="end_date"
                          :min="start_date"
                          @change="dateMenuReset"
                          @input="dateEnd = false"
                          class="font-theme date-picker-save-budget-modal"
                        ></v-date-picker>
                      </v-menu>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-row no-gutters class="standard-row font-theme" align="center">
                <v-col cols="12" sm="6" md="6" lg="6">
                  <v-row
                    no-gutters
                    class="standard-row font-theme pt-2"
                    align="center"
                  >
                    <v-col
                      class="custom-col-text"
                      cols="4"
                      sm="12"
                      md="6"
                      lg="6"
                      style="font-size: 14px"
                    >
                      งบที่บันทึก
                    </v-col>
                    <v-col
                      class="custom-col-textfield"
                      cols="8"
                      sm="12"
                      md="6"
                      lg="6"
                    >
                      <v-text-field
                        height="24"
                        readonly
                        color="black"
                        v-model="totalBudget"
                        background-color="#EAEAEA"
                        hide-details
                        outlined
                        class="pr-4 text-box-petty-cash-modal"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" sm="6" md="6" lg="6">
                  <v-row
                    no-gutters
                    class="standard-row font-theme pt-2"
                    align="center"
                  >
                    <v-col
                      class="custom-col-text"
                      cols="4"
                      sm="12"
                      md="6"
                      lg="6"
                      style="font-size: 14px"
                    >
                      Sub Team
                    </v-col>
                    <v-col
                      class="custom-col-textfield"
                      cols="8"
                      sm="12"
                      md="6"
                      lg="6"
                    >
                      <v-text-field
                        height="24"
                        color="black"
                        hide-details
                        outlined
                        v-model="cutBudgetData[0].sub_team"
                        class="pr-4 text-box-petty-cash-modal"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-col>
          </v-row>

          <!--------------------------------------------------- group --------------------------------------------------->
          <v-row
            no-gutters
            class="standard-row font-theme my-5 px-4"
            align="center"
            style="gap: 12px"
          >
            <v-row
              no-gutters
              v-for="(data, dataIndex) in cutBudgetData"
              :key="`${dataIndex}`"
              class="standard-row font-theme pb-3"
              align="center"
              style="border: 1px solid #a8a8a8; border-radius: 18px"
            >
              <v-row
                no-gutters
                v-for="(itemList, index) in data.description?.slice(0, 1)"
                :key="`${index}`"
                class="standard-row font-theme mt-3 mx-3"
                align="center"
              >
                <v-col
                  cols="12"
                  sm="12"
                  md="2"
                  lg="2"
                  class="d-flex justify-center mr-2 item-group-petty-cash-modal name-first-item-header-save-petty-cash-modal"
                >
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <span
                        class="font-theme text-center px-2 px-md-1"
                        v-on="on"
                        v-bind="attrs"
                      >
                        {{ data.document_id }}
                      </span>
                    </template>
                    <span class="font-theme">
                      {{ data.document_id }}
                    </span>
                  </v-tooltip>
                </v-col>
                <v-col
                  cols="12"
                  sm="12"
                  md="2"
                  lg="2"
                  class="mr-n4 mt-3 mt-md-0"
                >
                  <v-tooltip
                    top
                    :disabled="
                      itemList.group[0].group?.group_name ? false : true
                    "
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-autocomplete
                        hide-details
                        outlined
                        dense
                        :items="itemList?.group[0]?.dropdown_list"
                        v-model="itemList.group[0].group"
                        @change="
                          onGroupChange(
                            0,
                            itemList.group[0].group,
                            index,
                            dataIndex
                          )
                        "
                        :loading="itemList.group[0]?.loading_status"
                        v-on="on"
                        v-bind="attrs"
                        placeholder="Group"
                        item-text="group_name"
                        height="28"
                        append-icon="mdi-chevron-down"
                        item-color="#D9D9D9"
                        color="black"
                        :menu-props="{ bottom: true, offsetY: true }"
                        return-object
                        :rules="[(v) => !!v && !!v.group_id && !!v.group_name]"
                        required
                        class="font-theme pr-md-6 dropdown-group-save-budget-modal"
                      >
                        <template v-slot:item="data">
                          <v-list-item-content class="py-0">
                            <v-list-item-title
                              class="font-theme"
                              style="font-size: 12px; line-height: 20px"
                              >{{ data.item.group_name }}</v-list-item-title
                            >
                          </v-list-item-content>
                        </template>
                        <template v-slot:no-data>
                          <v-list-item>
                            <v-list-item-content>
                              <v-list-item-title
                                class="font-theme"
                                style="line-height: 20px"
                                >ไม่พบข้อมูล</v-list-item-title
                              >
                            </v-list-item-content>
                          </v-list-item>
                        </template>
                      </v-autocomplete>
                    </template>
                    <span class="font-theme">{{
                      itemList.group[0].group?.group_name
                    }}</span>
                  </v-tooltip>
                </v-col>
                <v-col
                  cols="12"
                  sm="12"
                  md="2"
                  lg="2"
                  class="mr-n4 mt-3 mt-md-0"
                >
                  <v-tooltip
                    top
                    :disabled="
                      itemList.group[1].group?.group_name ? false : true
                    "
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-autocomplete
                        hide-details
                        outlined
                        dense
                        :items="itemList?.group[1]?.dropdown_list"
                        v-model="itemList.group[1].group"
                        @change="
                          onGroupChange(
                            1,
                            itemList.group[1].group,
                            index,
                            dataIndex
                          )
                        "
                        :loading="itemList.group[1]?.loading_status"
                        :disabled="
                          itemList.group[0]?.group?.group_id &&
                          !itemList.group[1]?.loading_status
                            ? false
                            : true
                        "
                        v-on="on"
                        v-bind="attrs"
                        placeholder="Sub 1"
                        item-text="group_name"
                        height="28"
                        append-icon="mdi-chevron-down"
                        item-color="#D9D9D9"
                        color="black"
                        :menu-props="{ bottom: true, offsetY: true }"
                        return-object
                        :rules="[
                          (v) =>
                            itemList?.group[1]?.dropdown_list?.length === 0 ||
                            (!!v && !!v.group_name),
                        ]"
                        class="font-theme pr-md-6 dropdown-group-save-budget-modal"
                      >
                        <template v-slot:item="data">
                          <v-list-item-content class="py-0">
                            <v-list-item-title
                              class="font-theme"
                              style="font-size: 12px; line-height: 20px"
                              >{{ data.item.group_name }}</v-list-item-title
                            >
                          </v-list-item-content>
                        </template>
                        <template v-slot:no-data>
                          <v-list-item>
                            <v-list-item-content>
                              <v-list-item-title
                                class="font-theme"
                                style="line-height: 20px"
                                >ไม่พบข้อมูล</v-list-item-title
                              >
                            </v-list-item-content>
                          </v-list-item>
                        </template>
                      </v-autocomplete>
                    </template>
                    <span class="font-theme">{{
                      itemList.group[1].group?.group_name
                    }}</span>
                  </v-tooltip>
                </v-col>
                <v-col
                  cols="12"
                  sm="12"
                  md="2"
                  lg="2"
                  class="mr-n4 mt-3 mt-md-0"
                >
                  <v-tooltip
                    top
                    :disabled="
                      itemList.group[2].group?.group_name ? false : true
                    "
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-autocomplete
                        hide-details
                        outlined
                        dense
                        :items="itemList?.group[2]?.dropdown_list"
                        v-model="itemList.group[2].group"
                        @change="
                          onGroupChange(
                            2,
                            itemList.group[2].group,
                            index,
                            dataIndex
                          )
                        "
                        :loading="itemList.group[2]?.loading_status"
                        :disabled="
                          itemList.group[1]?.group?.group_id &&
                          !itemList.group[2]?.loading_status
                            ? false
                            : true
                        "
                        v-on="on"
                        v-bind="attrs"
                        placeholder="Sub 2"
                        item-text="group_name"
                        height="28"
                        append-icon="mdi-chevron-down"
                        item-color="#D9D9D9"
                        color="black"
                        :menu-props="{ bottom: true, offsetY: true }"
                        return-object
                        :rules="[
                          (v) =>
                            itemList?.group[2]?.dropdown_list?.length === 0 ||
                            (!!v && !!v.group_name),
                        ]"
                        class="font-theme pr-md-6 dropdown-group-save-budget-modal"
                      >
                        <template v-slot:item="data">
                          <v-list-item-content class="py-0">
                            <v-list-item-title
                              class="font-theme"
                              style="font-size: 12px; line-height: 20px"
                              >{{ data.item.group_name }}</v-list-item-title
                            >
                          </v-list-item-content>
                        </template>
                        <template v-slot:no-data>
                          <v-list-item>
                            <v-list-item-content>
                              <v-list-item-title
                                class="font-theme"
                                style="line-height: 20px"
                                >ไม่พบข้อมูล</v-list-item-title
                              >
                            </v-list-item-content>
                          </v-list-item>
                        </template>
                      </v-autocomplete>
                    </template>
                    <span class="font-theme">{{
                      itemList.group[2].group?.group_name
                    }}</span>
                  </v-tooltip>
                </v-col>
                <v-col
                  cols="12"
                  sm="12"
                  md="2"
                  lg="2"
                  class="mr-n4 mt-3 mt-md-0"
                >
                  <v-tooltip
                    top
                    :disabled="
                      itemList.group[3].group?.group_name ? false : true
                    "
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-autocomplete
                        hide-details
                        outlined
                        dense
                        :items="itemList?.group[3]?.dropdown_list"
                        v-model="itemList.group[3].group"
                        item-text="group_name"
                        :loading="itemList.group[3]?.loading_status"
                        :disabled="
                          itemList.group[2]?.group?.group_id &&
                          !itemList.group[3]?.loading_status
                            ? false
                            : true
                        "
                        v-on="on"
                        v-bind="attrs"
                        height="28"
                        append-icon="mdi-chevron-down"
                        placeholder="Sub 3"
                        item-color="#D9D9D9"
                        color="black"
                        :menu-props="{ bottom: true, offsetY: true }"
                        return-object
                        :rules="[
                          (v) =>
                            itemList?.group[3]?.dropdown_list?.length === 0 ||
                            (!!v && !!v.group_name),
                        ]"
                        class="font-theme pr-md-6 dropdown-group-save-budget-modal"
                      >
                        <template v-slot:item="data">
                          <v-list-item-content class="py-0">
                            <v-list-item-title
                              class="font-theme"
                              style="font-size: 12px; line-height: 20px"
                              >{{ data.item.group_name }}</v-list-item-title
                            >
                          </v-list-item-content>
                        </template>
                        <template v-slot:no-data>
                          <v-list-item>
                            <v-list-item-content>
                              <v-list-item-title
                                class="font-theme"
                                style="line-height: 20px"
                                >ไม่พบข้อมูล</v-list-item-title
                              >
                            </v-list-item-content>
                          </v-list-item>
                        </template>
                      </v-autocomplete>
                    </template>
                    <span class="font-theme">{{
                      itemList.group[3].group?.group_name
                    }}</span>
                  </v-tooltip>
                </v-col>
                <v-col
                  cols="10"
                  sm=""
                  md="2"
                  lg="2"
                  class="d-flex justify-center item-group-petty-cash-modal mt-3 mt-md-0 name-last-item-header-save-petty-cash-modal"
                >
                  {{ (Number(data.total_payment) || 0).toFixed(2) }}
                </v-col>
                <v-col
                  cols="2"
                  sm="auto"
                  md=""
                  lg=""
                  class="d-flex justify-center mt-3 mt-md-0 pl-3 pl-md-0"
                >
                  <v-btn
                    color="#0B68D6"
                    width="44"
                    height="28"
                    class="calendar-btn-save-petty-cash-modal"
                    @click="openPlanCutBudgetModal(data, itemList, dataIndex)"
                  >
                    <img
                      src="../assets/icon-calendar.png"
                      contain
                      style="height: 18px"
                    />
                  </v-btn>
                </v-col>
              </v-row>
            </v-row>
            <v-row
              no-gutters
              class="standard-row font-theme pl-3 pr-2"
              align="center"
            >
              <v-col cols="12" sm="12" md="12" lg="12" class="mt-3 mr-md-n3">
                <v-row no-gutters class="standard-row font-theme">
                  <v-col
                    cols="5"
                    sm="12"
                    md="2"
                    lg="2"
                    style="font-size: 14px"
                    class="mr-md-n3"
                  >
                    Remark
                  </v-col>
                  <v-col cols="7" sm="12" md="8" lg="8">
                    <v-textarea
                      hide-details
                      outlined
                      rows="3"
                      color="black"
                      v-model="cutBudgetData[0].remark"
                      class="pr-4 pr-md-0 pr-lg-4 remark-textarea-save-petty-cash-modal"
                    ></v-textarea>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-row>
        </v-row>
        <v-row
          no-gutters
          class="standard-row font-theme pr-7 d-flex justify-end"
          align="center"
        >
          <v-btn
            :disabled="!disabledBtnBudget"
            height="32"
            width="74"
            color="#0B68D6"
            @click="confirmAddSaveCutBudget()"
            style="
              box-shadow: none;
              color: white;
              border-radius: 5px;
              font-weight: 600;
              font-size: 16px;
              letter-spacing: 0.1px;
            "
          >
            ยืนยัน
          </v-btn>
        </v-row>
        <PlanCutBudgetModal ref="PlanCutBudgetDialog" />
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import { EventBus } from "../EventBus";
import { MainFunction } from "@/functions/mainFunction.js";
import PlanCutBudgetModal from "./PlanCutBudgetModal.vue";
export default {
  components: {
    PlanCutBudgetModal,
  },
  data: () => ({
    rules: {
      required: (v) => !!v || "Required.",
    },
    cutBudgetData: [
      {
        sub_team: null,
        in_budget: null,
        remark: null,
      },
    ],
    disabledBtnBudget: true,
    thisYear: new Date().getFullYear() + 543,
    selectorTypeBudget: "",
    dateStart: false,
    dateEnd: false,
    start_date: new Date().toISOString().substr(0, 10),
    end_date: new Date().toISOString().substr(0, 10),
    dialog: false,
    data212: ["Unit", "Month", "Year", "Job", "License", "Person"],
    type_year_selected: "ภายในปี",
    year_selected_start: null,
    year_selected_end: null,
    item_year: {
      from: [],
      to: [],
    },
    cashBack: false,
    typeBudgetItems: ["COST", "SGA", "RD"],
  }),
  mounted() {
    this.getYearList();
    EventBus.$on("toSaveSummaryFinance", this.open);
    EventBus.$on("afterPlanCutBudget", this.updatePlanBudget);
  },
  beforeDestroy() {
    EventBus.$off("toSaveSummaryFinance");
    EventBus.$off("afterPlanCutBudget");
  },
  watch: {
    dialog(newVal) {
      if (!newVal) {
        this.start_date = null;
        this.end_date = null;
        this.cutBudgetData.forEach((data) => {
          data.sub_team = null;
          data.in_budget = null;
          data.remark = null;
        });
        this.$refs.saveCutBudgetForm.resetValidation();
        this.checkDataSaveBudget();
      }
    },
  },
  computed: {
    startDateTextShow() {
      return MainFunction.shortDate(this.start_date || null);
    },
    endDateTextShow() {
      return MainFunction.shortDate(this.end_date || null);
    },
    selectedBiz() {
      return this.$store.state.confirmSelectedBiz;
    },
    totalBudget() {
      return this.cutBudgetData.reduce((sum, item) => {
        const value =
          item.doc_type === 'ใบยืมเงินทดรอง'
            ? item.total_advance_payment
            : item.amount_left

        return sum + (Number(String(value).replace(/,/g, '')) || 0)
      }, 0)
    }

  },

  methods: {
  open(data) {
      this.dataFromCreatePage = data;
      this.cutBudgetData = data.map(item => ({
        ...item,
        in_budget: true,
        total_payment:
          item.doc_type === 'ใบยืมเงินทดรอง'
            ? item.total_advance_payment
            : item.amount_left,
        description: item.description.map((desc, index) => ({
          ...desc,
          _id: null,
          item_id: String(index),
          discount: "",
          net: "",
        })),
      }));
      this.getGroupBudget(0);
      this.dialog = true;
    },
    updatePlanBudget(tempData = {}) {
      const docIndex = this.cutBudgetData.findIndex(
        (doc) => doc._id === tempData.transactionID
      );
      if (docIndex === -1) return;

      const budgetData = this.cutBudgetData[docIndex];

      budgetData.description.forEach((item, index) => {
        item.plan = tempData.period;
        item.net = tempData.description?.[index].net
          ? tempData.description?.[index].net.toString()
          : "0.00";
        item.discount = tempData.description?.[index].discount
          ? tempData.description?.[index].discount.toString()
          : "0.00";
      });

      budgetData.discount = MainFunction.addComma(
        budgetData.description
          .reduce((total, next) => {
            const discount = next.discount ?? "0.00";
            return total + Number(discount.toString().replace(/,/g, ""));
          }, 0)
          .toFixed(2)
      );

      budgetData.net = MainFunction.addComma(
        budgetData.description
          .reduce((total, next) => {
            const net = next.net ?? "0.00";
            return total + Number(net.toString().replace(/,/g, ""));
          }, 0)
          .toFixed(2)
      );
      this.$forceUpdate();
    },
    updateGroupForAllItems(level, groupObject, dataIndex) {
      const doc = this.cutBudgetData[dataIndex];
      if (!doc || !doc.description) return;

      doc.description.forEach((item) => {
        if (item.group && item.group[level]) {
          item.group[level].group = groupObject;
        }
      });

      this.$forceUpdate();
    },

    onGroupChange(level, groupObject, index, dataIndex) {
      this.updateGroupForAllItems(level, groupObject, dataIndex);
      this.getGroupBudget(level + 1, groupObject?.group_id, index, dataIndex);
    },

    updateAllBudgetType(val) {
      this.cutBudgetData.forEach((item) => {
        item.budget_type = val;
      });
      this.getGroupBudget(0);
    },

    async getGroupBudget(key, groupId = null, index = 0, dataIndex = null) {
      const cutBudgetdata =
        dataIndex !== null
          ? [this.cutBudgetData[dataIndex]]
          : this.cutBudgetData;
      cutBudgetdata.forEach((budgetData) => {
        if (key === 0) {
          for (let i = 0; i < budgetData.description.length; i++) {
            const tempGroup = {
              level: null,
              group: null,
              loading_status: false,
              dropdown_list: [],
            };
            const price = (budgetData.description[i].price || 0).toString();

            budgetData.description[i].group = [];
            budgetData.description[i].plan = [];
            budgetData.description[i].currency_exchange ||= "1";
            budgetData.description[i].item_id = budgetData.description[
              i
            ].discount = budgetData.description[i].discount
              ? MainFunction.addComma(
                  Number(
                    budgetData.description[i].discount?.replace(/,/g, "") *
                      Number(
                        budgetData.description[i].currency_exchange?.replace(
                          /,/g,
                          ""
                        )
                      )
                  ).toFixed(2)
                )
              : "0.00";
            budgetData.description[i].net = MainFunction.addComma(
              (
                Number(price.replace(/,/g, "")) -
                Number(budgetData.description[i].discount?.replace(/,/g, ""))
              ).toFixed(2) || "0.00"
            );

            for (let j = 0; j <= 3; j++) {
              budgetData.description[i].group.push({
                ...tempGroup,
                level: j,
                loading_status: j === 0 ? true : false,
              });
            }
          }
        } else {
          const propsForClearData = {
            1: ["1", "2", "3"],
            2: ["2", "3"],
            3: [],
          };
          if (!groupId) {
            propsForClearData[key - 1].forEach((e, i) => {
              if (i !== 0) {
                budgetData.description[index].group[e].group = null;
                budgetData.description[index].group[e].dropdown_list = [];
              }
            });
            this.$forceUpdate();
            return;
          } else {
            propsForClearData[key].forEach((e) => {
              budgetData.description[index].group[e].group = null;
              budgetData.description[index].group[e].dropdown_list = [];
            });
            budgetData.description[index].group[key].loading_status = true;
          }
        }
      });
      this.$forceUpdate();
      this.disabledBtnBudget = false;
      try {
        let { data } = await this.axios.post(
          `${this.$api_url}/group_budget/api/v1/get_group_budget`,
          {
            tax_id: this.selectedBiz?.tax_id || null,
            budget_type: [this.cutBudgetData[0].budget_type] || null,
            upper_group_id: groupId || [],
            first_year: new Date().getFullYear(),
            last_year: new Date().getFullYear(),
          }
        );
        if (data.status && data.data.length) {
          cutBudgetdata.forEach((budgetData) => {
            if (key === 0) {
              for (let i = 0; i < budgetData.description.length; i++) {
                budgetData.description[i].group[0].dropdown_list = data.data;
              }
            } else {
              budgetData.description[index].group[key].dropdown_list =
                data.data;
            }
          });
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.disabledBtnBudget = true;
        cutBudgetdata.forEach((budgetData) => {
          if (key === 0) {
            for (let i = 0; i < budgetData.description.length; i++) {
              budgetData.description[i].group[0].loading_status = false;
            }
          } else {
            budgetData.description[index].group[key].loading_status = false;
          }
        });
        this.$forceUpdate();
      }
    },
    openPlanCutBudgetModal(data, itemList, dataIndex) {
      const totalPrice =
        data.doc_type === 'ใบยืมเงินทดรอง'
          ? data.total_advance_payment
          : data.amount_left;
      const descriptionWithNet =
        data.description?.map((item) => ({
          ...item,
          net: Number(item.price) || 0,
        })) || [];
      if (this.$refs.saveCutBudgetForm.validate()) {
        const tempData = {
          index: dataIndex,
          transaction_id: data._id,
          end_date: this.end_date || null,
          start_date: this.start_date || null,
          period: itemList?.plan || null,
          saved_budget: totalPrice.toString() || null,
          save_budget_id: this.dataFromCreatePage?._id || null,
          document_status: this.dataFromCreatePage?.document_status || null,
          document_status_permission:
            this.dataFromCreatePage?.document_status_permission || null,
          discount: itemList?.discount || null,
          net: totalPrice.toString() || null,
          is_product_discount: this.isProductsDiscount || null,
          description: descriptionWithNet || null,
        };
        EventBus.$emit("planCutBudgetModal", tempData);
      } else {
        return this.alert("กรอกข้อมูลให้ครบถ้วน", "Warning", "info");
      }
    },
    cutItemName(name) {
      if (name.length > 13) {
        return `${name.substring(0, 13)}...`;
      } else {
        return name;
      }
    },
    checkDataSaveBudget() {
      EventBus.$emit("toSummaryModal");
      this.dialog = false;
    },
    async confirmAddSaveCutBudget() {
      if (!this.$refs.saveCutBudgetForm.validate()) {
        return this.alert("กรอกข้อมูลให้ครบถ้วน", "Warning", "info");
      }

      for (
        let dataIndex = 0;
        dataIndex < this.cutBudgetData.length;
        dataIndex++
      ) {
        const data = this.cutBudgetData[dataIndex];
        for (let i = 0; i < data.description.length; i++) {
          if (!data.description[i].plan.length) {
            return this.alert(
              `กรุณาบันทึก Plan ให้ครบทุกรายการ`,
              "Warning",
              "info"
            );
          }
        }
      }
      if (this.editDataMode) {
        return this.editSaveBudgetAndPlanBudget();
      }
      if (this.dataFromCreatePage[0].save_budget_id) {
        let planUpdated = [];
        for (
          let dataIndex = 0;
          dataIndex < this.dataFromCreatePage.length;
          dataIndex++
        ) {
          const oldDoc = this.dataFromCreatePage[dataIndex];
          const newDoc = this.cutBudgetData[dataIndex];

          for (let i = 0; i < oldDoc.description.length; i++) {
            for (let j = 0; j < oldDoc.description[i].plan.length; j++) {
              if (
                !_.isEqual(
                  oldDoc.description[i].plan[j],
                  newDoc.description[i].plan[j]
                )
              ) {
                newDoc.description[i].index = i;
                planUpdated.push(newDoc.description[i]);
                j = oldDoc.description[i].plan.length;
              }
            }
          }
        }

        if (planUpdated.length) {
          this.updatePlanSaveBudget(planUpdated);
        } else {
          this.dialog = false;
        }
        return;
      }

      const payload = {
        transaction_id: this.cutBudgetData.map((doc) => ({
          budget_end_year: Number(
            this.end_date?.split("-")[0] || new Date().getFullYear()
          ),
          budget_start_year: Number(
            this.start_date?.split("-")[0] || new Date().getFullYear()
          ),
          total_budget: doc.total_item_price?.replace(/,/g, "") || null,
          saved_budget: doc.total_item_price?.replace(/,/g, "") || null,
          discount: doc.discount?.replace(/,/g, "") || null,
          net: doc.net?.replace(/,/g, "") || null,
          from: "summary_finance",
          item: doc.description.map((e, index) => ({
            plan: e?.plan || null,
            item_id: index.toString() || "0",
            item_name:
              e[Object.keys(e).find((k) => k.startsWith("sub_item"))] || null,
            item_price: e?.price.toString().replace(/,/g, "") || null,
            discount: e?.discount.replace(/,/g, "") || null,
            net: (e?.net || "0").toString().replace(/,/g, ""),
            group:
              e?.group
                ?.map(
                  (g) =>
                    g?.group && g.group?.group_id?.length && { ...g?.group }
                )
                .filter(Boolean) || null,
            _id: e?._id || null,
          })),
          tax_id: this.selectedBiz.tax_id,
          start_date: this.start_date,
          end_date: this.end_date,
          in_off_budget:
            typeof doc.in_budget === "boolean" ? doc.in_budget : null,
          type_budget: doc.budget_type || null,
          remark: doc.remark || null,
          sub_team: doc.sub_team || null,
          budget_year_type: this.type_year_selected,
          group_first_year: this.year_selected_start,
          transaction_id: doc._id || null,
          group_last_year:
            this.type_year_selected === "ภายในปี"
              ? this.year_selected_start
              : this.year_selected_end,
        })),
      };

      try {
        this.loadingAddSaveBudget = true;
        const { data } = await this.axios.post(
          `${this.$api_url}/summary_finance/api/v1/add_savebudget_finance`,
          payload
        );
        if (data.status) {
          if (data.message === "insufficient plan balance") {
            return this.alert("งบประมาณไม่เพียงพอ", "Warning", "info");
          }
          this.dialog = false;
          this.alert("บันทึกงบประมาณสำเร็จ", "Success", "success");
        }
      } catch (error) {
        console.log(error);
        this.alert("บันทึกงบประมาณไม่สำเร็จ", "Fail", "error");
      } finally {
        this.loadingAddSaveBudget = false;
      }
    },
    getYearList() {
      const startYear = 2023;
      const currentYear = new Date().getFullYear();
      this.year_selected_start = currentYear.toString();
      this.year_selected_end = currentYear.toString();
      const result = Array.from(
        { length: currentYear - startYear + 1 },
        (_, index) => (startYear + index).toString()
      );
      this.$set(this.item_year, "from", result);
      this.$set(this.item_year, "to", result);
    },
    dateMenuReset() {
      this.cutBudgetData.forEach((data) => {
        data.description.forEach((item) => {
          item.plan = [];
          item.net = "";
          item.discount = "";
        });
      });
    },
    alert(title = "", text = "", icon = "info") {
      this.$swal({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        icon: icon,
        title: `<b class="alert-success-title">${title}</b>`,
        text: text,
        showClass: {
          popup: "animate-show-card",
        },
        customClass: {
          container: "alert-card-block",
          popup: "alert-card-success",
          title: "alert-title-block",
          htmlContainer: "alert-text-box",
          icon: "alert-icon",
        },
      });
    },
  },
};
</script>
<style>
.card-save-petty {
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 20px !important;
}

.check-box-petty-cash-modal {
  font-size: 13px;
  color: black;
}

.text-box-petty-cash-modal .v-input__control .v-input__slot {
  min-height: auto;
  padding: 0px 8px !important;
  font-size: 13px;
}

.dropdown-group-petty-cash-modal {
  border-radius: 0px;
  font-size: 13px;
}

.dropdown-group-petty-cash-modal.v-input--dense.v-text-field--outlined
  > .v-input__control
  > .v-input__slot {
  min-height: auto;
}

.dropdown-group-petty-cash-modal.v-text-field.v-text-field--enclosed:not(
    .v-text-field--rounded
  )
  > .v-input__control
  > .v-input__slot {
  padding: 0 4px;
}

.dropdown-group-petty-cash-modal .v-icon.v-icon {
  font-size: 15px;
}

.dropdown-group-petty-cash-modal .v-input__icon {
  min-width: auto;
  width: auto;
}

.dropdown-group-petty-cash-modal.v-input--dense:not(
    .v-text-field--solo
  ).v-text-field--outlined
  .v-input__append-inner {
  padding-top: 2px;
}

.item-group-petty-cash-modal {
  background-color: #e7e7e7;
  min-height: 28px;
  line-height: 28px;
  font-weight: 700;
  font-size: 13px;
}

.name-first-item-header-save-petty-cash-modal {
  border-radius: 10px 0px 0px 10px;
}

.name-last-item-header-save-petty-cash-modal {
  border-radius: 0px 10px 10px 0px;
}

.dropdown-external-petty-cash-modal {
  border-radius: 5px;
  font-size: 13px;
}

.dropdown-external-petty-cash-modal.v-input--dense.v-text-field--outlined
  > .v-input__control
  > .v-input__slot {
  min-height: auto;
}

.dropdown-external-petty-cash-modal.v-text-field.v-text-field--enclosed:not(
    .v-text-field--rounded
  )
  > .v-input__control
  > .v-input__slot {
  padding-left: 8px;
  padding-right: 0px;
}

.dropdown-external-petty-cash-modal .v-icon.v-icon {
  font-size: 15px;
}

.dropdown-external-petty-cash-modal .v-input__icon {
  min-width: auto;
  width: auto;
}

.dropdown-group-heard-petty-cash-modal {
  border-radius: 0px;
  font-size: 13px;
}

.dropdown-group-heard-petty-cash-modal.v-input--dense.v-text-field--outlined
  > .v-input__control
  > .v-input__slot {
  min-height: auto;
  border-radius: 10px 0px 0px 10px;
}

.dropdown-group-heard-petty-cash-modal.v-text-field.v-text-field--enclosed:not(
    .v-text-field--rounded
  )
  > .v-input__control
  > .v-input__slot {
  padding: 0 4px;
  padding-left: 10px;
}

.dropdown-group-heard-petty-cash-modal .v-icon.v-icon {
  font-size: 15px;
}

.dropdown-group-heard-petty-cash-modal .v-input__icon {
  min-width: auto;
  width: auto;
}

.calendar-btn-save-petty-cash-modal {
  border-radius: 10px;
}

.calendar-btn-save-petty-cash-modal:not(.v-btn--round).v-size--default {
  min-width: auto;
  box-shadow: none;
}

.remark-textarea-save-petty-cash-modal.v-text-field--enclosed:not(
    .v-text-field--rounded
  )
  > .v-input__control
  > .v-input__slot {
  padding: 0px;
}

.remark-textarea-save-petty-cash-modal {
  line-height: 24px;
  font-size: 13px;
}

.remark-textarea-save-petty-cash-modal > .v-input__control > .v-input__slot {
  min-height: 24px !important;
}

@media only screen and (max-width: 520px) {
  .custom-col-text,
  .custom-col-text-sub,
  .custom-col-textfield,
  .custom-col-textfield-sub,
  .custom-col-textarea {
    flex: 0 0 100%;
    max-width: 100%;
  }
}

@media only screen and (max-width: 600px) {
  .custom-col-text,
  .custom-col-text-sub {
    padding-right: 8px !important;
  }
}

@media only screen and (max-width: 959px) {
  .name-first-item-header-save-petty-cash-modal {
    border-radius: 10px 10px 0px 0px;
  }

  .dropdown-group-heard-petty-cash-modal.v-input--dense.v-text-field--outlined
    > .v-input__control
    > .v-input__slot {
    min-height: auto;
    border-radius: 10px 10px 0px 0px;
  }

  .name-last-item-header-save-petty-cash-modal {
    border-radius: 0px 0px 0px 10px;
  }

  .calendar-btn-save-petty-cash-modal {
    border-radius: 0px 0px 10px 0px;
  }
}

@media only screen and (min-width: 960px) {
  .custom-container-col {
    flex: 0 0 62.5%;
    max-width: 62.5%;
  }
  .custom-container-col-sub {
    flex: 0 0 37.5%;
    max-width: 37.5%;
  }
  .custom-col-text {
    flex: 0 0 39.5%;
    max-width: 39.5%;
  }
  .custom-col-textfield {
    flex: 0 0 60.5%;
    max-width: 60.5%;
  }
}
</style>
